import sideload from "./sideload.vue"

const Sideload = {
  install(Vue) {
    Vue.component("sideload", sideload)
    Vue.prototype.$sideload = async function(component, position, params = {}) {
      try {
        if (!component || typeof params !== "object") return false
        const promise = await _$.progress.create()

        const $package = {
          component: component,
          position: ["left", "right"].indexOf(position) > -1 ? position : "left",
          params: params,
          resolve: e => {
            promise.resolve(e)
          },
          reject: e => {
            promise.reject(e)
          }
        }

        _$.vue.$emit("sideload", $package)

        return promise.done
      } catch (err) {
        return _$.error(err)
      }
    }
  }
}

export default Sideload
